import Vue from "vue";
// 页面入口
import App from "./App.vue";
// vue路由
import router from "./router";
// 状态管理工具
import store from "./store";
// 移动端 UI库
import loadVantUi from "./plugins/vant-ui";
// PC端 UI库
import loadElUi from "./plugins/element-ui";

/*********公共自定义组件**********/
import ComButton from "./components/ComButton";
import icon from "./components/icon";
import SlideVerify from "./components/mobile/slide-verify";
/*********公共自定义组件**********/

/*********工具函数**********/
import { useMessage, deviceType, hidePhoneNumber } from "./utils";
import debounce from "./directive/debounce";
import { encrypt, decrypt } from "./utils/crypto.js";
Vue.prototype.$encrypt = encrypt;
Vue.prototype.$decrypt = decrypt;
// console.log("process.env", process.env);
Vue.prototype.$aesKey = process.env.VUE_APP_KEY;
Vue.prototype.$aesIv = process.env.VUE_APP_IV;
/*********工具函数**********/

/*********自定义指令**********/
/*********自定义指令**********/

/*********加载UI库**********/
loadVantUi(Vue);
loadElUi(Vue);
/*********加载UI库**********/

Vue.component("com-button", ComButton);
Vue.component("icon", icon);
// 图形验证码
Vue.component("slide-verify", SlideVerify);

// 区分手机 Pc
const { isWechat, isPc } = deviceType();

Vue.prototype.showMobileComponent = document.body.clientWidth <= 768;

Vue.directive("debounce", debounce);

// 运行环境：先微信（含 PC 微信）后 PC
// jsapi = 微信内（手机微信 + PC 微信）
// pc    = 普通 PC 浏览器
// h5    = 普通移动端浏览器
Vue.prototype.runEnv = isWechat ? 'jsapi' : isPc ? 'pc' : 'h5';

// 若 showMobileComponent 需要随窗口变化更新，加 resize 监听（不需要可删）
window.addEventListener('resize', () => {
    Vue.prototype.showMobileComponent = document.body.clientWidth <= 768;
});

// 微信登录url地址
Vue.prototype.wxLoginUrl = "http://wxzf.sdjys.org/wechat/openid?secret_key=StqVTlQQsF8F&uri=lingdinghu";
// 区分手机 Pc message提示
Vue.prototype.$useMessage = useMessage;
Vue.prototype.$hidePhoneNumber = hidePhoneNumber;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
